<template>
  <div>
    <Header :coverPhoto="coverPhoto"></Header>
    <div class="info">
      <div class="title">
        <h3>公司简介 / Company Profile</h3>
        <p>公司简介</p>
      </div>
      <div class="intro-content" v-html="introContent"></div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/assets/components/Header'
import Footer from '@/assets/components/Footer'
import url from '@/assets/public/url'
import axios from 'axios'
export default {
  name: "CompanyIntro",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      requestUrl: url.url,
      introContent: '',
      coverPhoto: ''
    }
  },
  methods: {
    getIntro: function () {
      var self = this
      var info = {
        page: 1,
        rows: 10,
        newsDirectoriesId: 'a2c3ed88-5ea4-4a60-8af6-f25733e6886f',
      }
      self.isLoading = true
      axios.get(self.requestUrl + '/news/app/newscontent/listpagenewscontentrelease', {
        params: info
      }).then(function (res) {
        self.getIntroDetail(res.data.rows[0].newsContentId)
      })
    },
    getIntroDetail: function (id) {
      var self = this
      axios.get(self.requestUrl + '/news/app/newscontent/getnewscontentbyidrelease/' + id).then(function (res) {
        self.introContent = res.data.newsContentContent
        self.isLoading = false
      })
    },
    // 获取版块介绍
    getBoxIntro: function () {
      var self = this
      axios.get(self.requestUrl + '/news/app/newsdirectories/getnewsdirectoriesbyidrelease/a2c3ed88-5ea4-4a60-8af6-f25733e6886f').then(function (res) {
        self.coverPhoto = res.data.directoriesPhoto
      })
    },
  },
  mounted() {
    this.getIntro()
    this.getBoxIntro()
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import "~styles/public.styl"
.banner, .banner img
  width 100%
  height 400px
.info
  width 1200px
  margin 35px auto
  .title
    text-align center
    padding 25px 0
    border-bottom 1px solid $main-blue
    margin-bottom 50px
    h3
      font-size 28px
      color #666
      font-weight normal
      margin-bottom 15px
    p
      font-size 14px
      color #999

  .info-search
    overflow hidden
    em
      float left
      height 40px
      line-height 40px
      font-size 16px
      font-weight bold
      color $main-blue
    .search-box
      float left
      margin-right 20px
      font-size 0
      .search-title
        display inline-block
        width 100px
        height 40px
        line-height 40px
        background $main-blue
        color #fff
        font-size 14px
        vertical-align top
        text-align center
      select, input
        width 160px
        height 40px
        border 1px solid  #ddd
        padding 0 10px
        box-sizing border-box
        vertical-align top
    button
      display block
      float left
      border none
      width 80px
      height 40px
      color #ffffff
      background $main-blue
      cursor pointer
  .info-list
    margin-top 50px
    ul
      min-height 500px
      li
        box-shadow 0 0 10px #EEE
        border-radius 5px
        overflow hidden
        margin-bottom 15px
        cursor pointer
        &:hover
          background #eee
        .info-title
          padding 0 20px
          height 40px
          line-height 40px
          margin-bottom 15px
          span
            display inline-block
            width 90px
            font-size 16px
            color #fff
            font-weight bold
            border-bottom-right-radius 20px
            text-align center
            &.type1
              background #006cbd
            &.type2
              background #b71e23
            &.type3
              background #2c367e
            &.type4
              background #a0a0a0
        .info-intro
          padding 0 20px 20px
          p
            font-size 14px
            color #333
            line-height 25px
          .address-time
            overflow hidden
            margin-top 20px
            font-size 14px
            color $main-blue
            .address
              float left
            .time
              float right
.intro-content
  padding 20px
  //border 1px solid #eee
  min-height 500px
</style>



// WEBPACK FOOTER //
// src/pages/CompanyIntro/CompanyIntro.vue